import axios from 'axios';
import { setAlert } from './alert';
import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CLEAR_PROFILE,
  CLEAR_ALLCANDS, SET_IP, SET_DBCALL, RESET_DBCALL,
} from './types';
import setAuthToken from '../utils/setAuthToken';

// Load User
export const loadUser = () => async dispatch => {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }

  try {

    dispatch({
      type: SET_DBCALL
    });

    const res = await axios.get('/api/auth');

    dispatch({
      type: USER_LOADED,
      payload: res.data
    });

    dispatch({
      type: RESET_DBCALL
    });

    

  } catch (err) {
    
    dispatch({
      type: RESET_DBCALL
    });

      if(err.response.status === 403)
      {
        dispatch({ type: LOGOUT });
        dispatch({ type: CLEAR_PROFILE });
        dispatch({ type: CLEAR_ALLCANDS });    
    
        dispatch(setAlert("SESSION EXPIRED. LOGIN AGAIN", 'danger'));
        //const res = await axios.get(`/api/auth/logout`);
      }
      else {

        dispatch({
          type: AUTH_ERROR
        });
        
      }

  }
};

export const getClientIp = () => async dispatch => {
  try {
  
    const res = await axios.get(`/api/auth/getip`);

    dispatch({
      type: SET_IP,
      payload: res.data
    });
    
  } 
  
  catch (err) {

      console.log("Catch");
      
      dispatch(setAlert(err.response.data.msg, 'danger'));
      
      /*console.log(err.response.data);
      const errors = err.response.data;

      if(errors) {
          errors.forEach(error => dispatch(setAlert(errors, 'danger')));
      }*/

  }
};




//register

export const register = ({ username, password, tfcname, district, ltype }) => async dispatch => {
    const config = {
        headers: {
            'Content-type': 'application/json'            
        }
    }

    const body = JSON.stringify({ username, password, tfcname, district, ltype });

    try {
        console.log("dispatched");
        const res = await axios.post('/api/users', body, config);
        console.log("Returned from db");
        dispatch({
                type: REGISTER_SUCCESS,
                payload: res.data
        });

        dispatch(setAlert("Registration Successful", 'success'));

    } catch (err) {

        const errors = err.response.data.errors;

        if(errors) {
            errors.forEach(error => {
                dispatch(setAlert(error.msg, 'danger'));
            });
        }
        dispatch({
            type: REGISTER_FAIL
        });
    }
};

export const register2 = (formData) => async dispatch => {
  const config = {
      headers: {
          'Content-type': 'application/json'            
      }
  }
  console.log("Requesting call to register " + formData.username + formData.password + formData.tfcname + formData.ltype);
  const body = JSON.stringify(formData);
 
  try {
      console.log("dispatched");
      const res = await axios.post('/api/users/reg', body, config);
      console.log("Returned from db");
      dispatch({
              type: REGISTER_SUCCESS,
              payload: res.data
      });

      dispatch(setAlert("Registration Successful", 'success'));

  } catch (err) {

      const errors = err.response.data.errors;

      if(errors) {
          errors.forEach(error => {
              dispatch(setAlert(error.msg, 'danger'));
          });
      }
      dispatch({
          type: REGISTER_FAIL
      });
  }
};


// Login User
export const login = (username, password) => async dispatch => {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
  
    dispatch({
      type: SET_DBCALL
    });

    const body = JSON.stringify({ username, password });
  
    try {
      const res = await axios.post('/api/auth', body, config);
  
      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data
      });
  
      dispatch(loadUser());
    } catch (err) {

      dispatch({
        type: RESET_DBCALL
      });


      if(err.response.data.msg === "auth")
          dispatch(setAlert(" You are not authorized user", 'danger'));


      const errors = err.response.data.errors;
  
      if (errors) {
        errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
      }
  
      dispatch({
        type: LOGIN_FAIL
      });
    }
  };
  
  // Logout / Clear Profile
  export const logout = () => dispatch => {
    //dispatch({ type: CLEAR_PROFILE });
    dispatch({ type: LOGOUT });
    dispatch({ type: CLEAR_PROFILE });
    dispatch({ type: CLEAR_ALLCANDS });
  };
  